export default "__VITE_ASSET__D0JGe$du__"